import { Box, Grid } from "@mui/material";
import { useState } from "react";

import { Ticker } from "../components/Ticker/Ticker";

const presale1Date = new Date(new Date().setDate(21)).setHours(14);
const presale2Date = new Date(new Date().setDate(21)).setHours(0, 0, 0, 0);
const presale3Date = new Date(new Date().setDate(21)).setHours(0, 0, 0, 0);

function CountDown() {
  const [tickerVisible, setTickerVisible] = useState(true);
  const tickerEl = tickerVisible ? <Ticker futureDate={presale1Date} /> : null;

  return (
    <div id="Pre-Sales" className={""}>
      <Box>{tickerEl}</Box>
    </div>
  );
}

export default CountDown;
